/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2026 HG Digital/Setera
 * Todos os direitos reservados.
 *
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 18-08-2026 11:18:04
 * Autor     : Diego Brock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

/** Senha incorreta no POST /auth/step-up (401). */
export const STEP_UP_WRONG_PASSWORD = 'STEP_UP_WRONG_PASSWORD';

/** Sessão insuficiente / 403 insufficient_user_authentication. */
export const INSUFFICIENT_USER_AUTHENTICATION = 'INSUFFICIENT_USER_AUTHENTICATION';

/**
 * Erro tipado do fluxo de step-up.
 */
export class StepUpHttpError extends Error {
  code: string;
  status?: number;

  constructor(code: string, message: string, status?: number) {
    super(message);
    this.name = 'StepUpHttpError';
    this.code = code;
    this.status = status;
  }
}

/**
 * Indica 403 por falta de reautenticação (mesmo critério do setera-admin-web).
 *
 * @param err erro HTTP (Angular HttpErrorResponse ou equivalente)
 * @returns true se o cliente deve reabrir o dialog de senha
 */
export function isInsufficientAuthError(err: any): boolean {
  if (!err) {
    return false;
  }
  if (err instanceof StepUpHttpError && err.code === INSUFFICIENT_USER_AUTHENTICATION) {
    return true;
  }
  const status = err.status;
  const body = err.error || err.body || {};
  const code = body.code;
  const headers = err.headers;
  const wwwAuth =
    headers && typeof headers.get === 'function'
      ? headers.get('WWW-Authenticate') || headers.get('www-authenticate') || ''
      : '';
  return (
    status === 403 &&
    (String(wwwAuth).indexOf('insufficient_user_authentication') >= 0 ||
      code === INSUFFICIENT_USER_AUTHENTICATION ||
      code === 'INSUFFICIENT_AUTHENTICATION')
  );
}

/**
 * Indica se a URL é o endpoint de step-up (não deve disparar logout em 401).
 *
 * @param url URL da requisição
 * @returns true se for POST /auth/step-up
 */
export function isStepUpRequestUrl(url: string): boolean {
  return !!url && url.indexOf('/auth/step-up') >= 0;
}
